import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const POPUP_Z_INDEX = "10";
const FOCUS_OUTLINE_WIDTH = "2px";
const FOCUS_OUTLINE_INSET_OFFSET = "-2px";

export const useStyles = makeStyles({
  sidebarFooter: {
    borderTop: `1px solid ${projectIqTokens.sidebarBorder}`,
    flexShrink: 0,
  },
  actionRow: {
    display: "flex",
    borderBottom: `1px solid ${projectIqTokens.sidebarBorder}`,
  },
  actionRowCollapsed: {
    flexDirection: "column",
  },
  backToAims: {
    flex: "1 1 0%",
    minWidth: 0,
    justifyContent: "center",
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    borderRadius: "0",
    color: projectIqTokens.sidebarFadedText,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    gap: designTokens.spacing[1],
    overflow: "hidden",
    whiteSpace: "nowrap",
    ":hover": {
      color: designTokens.neutral.white,
      backgroundColor: projectIqTokens.sidebarHover,
    },
  },
  inlineIcon: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  backToAimsCollapsed: {
    flex: "0 0 auto",
    width: "100%",
    maxWidth: "none",
    justifyContent: "center",
    padding: `${designTokens.spacing[2]} 0`,
  },
  userMenuArea: {
    position: "relative",
  },
  userProfileTrigger: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    overflow: "hidden",
    justifyContent: "flex-start",
    textAlign: "left",
    borderRadius: "0",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    transition: `background-color ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: projectIqTokens.sidebarHover,
      border: "none",
    },
    ":focus-visible": {
      outline: `${FOCUS_OUTLINE_WIDTH} solid ${designTokens.accent[500]}`,
      outlineOffset: FOCUS_OUTLINE_INSET_OFFSET,
    },
  },
  userProfileTriggerCollapsed: {
    justifyContent: "center",
    padding: `${designTokens.spacing[3]} 0`,
    minWidth: 0,
    maxWidth: "100%",
    gap: 0,
  },
  userMenuPopup: {
    position: "absolute",
    bottom: "100%",
    left: designTokens.spacing[3],
    right: designTokens.spacing[3],
    zIndex: POPUP_Z_INDEX,
    marginBottom: designTokens.spacing[1],
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
    transition: `opacity ${designTokens.transition.fast}`,
  },
  userInfoHidden: {
    opacity: 0,
    pointerEvents: "none",
    width: 0,
    flex: "unset",
  },
  userName: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
    color: designTokens.neutral.white,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  userCompany: {
    fontSize: "11px",
    color: projectIqTokens.sidebarFadedText,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
